import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ba627566")
const _hoisted_1 = ["loading", "loadingLabel", "size", "circle"]
const _hoisted_2 = {
  class: "flex w-44 flex-col overflow-hidden rounded-lg bg-[#2e2433] px-[20px] py-[15px] leading-[20px]",
  style: {
        'box-shadow': 'inset 0px 0px 2px #fbaaff',
        'border-radius': '22px',
      }
}
const _hoisted_3 = {
  class: "menu-item menu-link",
  href: "https://discord.gg/gFEaCXACF4",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " Discord ", -1)
const _hoisted_5 = {
  class: "menu-item menu-link",
  href: "https://docs.polarisfinance.io/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Docs ", -1)
const _hoisted_7 = {
  class: "menu-item menu-link",
  href: "https://www.apeoclock.com/launch/polaris-finance-genesis-pools-launch/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, " KYC ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Discord = _resolveComponent("Discord")!
  const _component_Docs = _resolveComponent("Docs")!
  const _component_Kyc = _resolveComponent("Kyc")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, { noPad: "" }, {
    activator: _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args))),
        class: _normalizeClass(["btn btn-menu flex flex-row pb-[10px] pt-0 text-base", { btn: _ctx.upToLargeBreakpoint }]),
        loading: _ctx.isLoadingProfile,
        loadingLabel: _ctx.upToLargeBreakpoint ? '' : _ctx.$t('connecting'),
        color: "white",
        size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
        circle: _ctx.upToLargeBreakpoint
      }, null, 10, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Discord)
        ]),
        _createElementVNode("a", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Docs)
        ]),
        _createElementVNode("a", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Kyc)
        ])
      ])
    ]),
    _: 1
  }))
}